/* React hooks */
import { useEffect } from "react";
/* Components */
import { useLocation } from "react-router-dom";
import { getCountryList } from "../../api/admin/addressReq";
import useAuth from "../../hooks/useAuth";
import useData from "../../hooks/useData";
import { validateFormInput } from "../../helper/tools";
import CityNameZipSuggest from "../../components/common/input-layout/CityNameZipSuggest";
import DateInput from "../../components/common/input-layout/DateInput";
import useDeceased from "../../hooks/useDeceased";


export default function FormDeathInfos({ fullForm, setFullForm }) {

    const { auth } = useAuth();
    const token = auth.token;
    const { countryList, setCountryList, selectedDeathplace } = useData();
    const { newForm, setNewForm } = useDeceased();
    const { pathname } = useLocation();

    const onChange = (e) => {
        setFullForm(prevForm => {
            const newValues = { ...prevForm, [e.target.name]: e.target.value };
            
            if (pathname?.includes("nouveau")) {
                setNewForm({ ...newForm, ...newValues });
            }
            
            return newValues;
        });

        validateFormInput(e);
    };


    const onChangeDeathPlaceData = (e) => {

        const fieldMap = {
            'deathZipcode': 'zipcode',
            'deathCity': 'city',
            'deathCountry': 'country'
        };
        
        const fieldKey = fieldMap[e.target.name] || e.target.name;
        
        setFullForm(prevForm => {
            const newValues = { 
                ...prevForm, 
                deathplace: { 
                    ...prevForm?.deathplace, 
                    [fieldKey]: e.target.value 
                } 
            };
            
            if (pathname?.includes("nouveau")) {
                setNewForm(newValues);
            }
            
            return newValues;
        });

        validateFormInput(e);
    };


    const apiCountryList = async () => {
        const response = await getCountryList(token)
        setCountryList(response)
    }

    useEffect(() => {
        apiCountryList()
    }, [token]);

    useEffect(() => {
        if (!fullForm?.deathplace?.country) {
            setFullForm(prevForm => ({
                ...prevForm,
                deathplace: {
                    ...prevForm?.deathplace,
                    country: "FR"
                }
            }));
        }
    }, []);

    // Ecouter les changements de selectedDeathplace depuis le contexte
    useEffect(() => {
        if (selectedDeathplace?.city_zip) {
            setFullForm(prevForm => {
                const currentZip = prevForm?.deathplace?.zipcode;
                const currentCity = prevForm?.deathplace?.city;
                const newZip = selectedDeathplace?.zip;
                const newCity = selectedDeathplace?.name;

                // Si les valeurs sont identiques, ne rien faire
                if (currentZip === newZip && currentCity === newCity) {
                    return prevForm;
                }

                const newValues = {
                    ...prevForm,
                    deathplace: {
                        ...prevForm?.deathplace,
                        zipcode: newZip,
                        city: newCity
                    }
                };

                if (pathname?.includes("nouveau")) {
                    setNewForm(newValues);
                }

                return newValues;
            });
        }
    }, [selectedDeathplace?.city_zip, pathname]);

    return (
        <fieldset>
            <legend>Informations de décès</legend>
            <div className="form-input">
                <label className="required" htmlFor="deathDate">Date de décès</label>
                <DateInput
                    placeholder="Date de décès"
                    required={true}
                    max="9999-12-31"
                    name="deathDate"
                    value={fullForm?.deathDate || ""}
                    onChange={onChange} />
            </div>
            {(!fullForm?.deathplace?.country || fullForm?.deathplace?.country === "FR") &&
                <CityNameZipSuggest city={fullForm?.deathplace?.city || ""} zipcode={fullForm?.deathplace?.zipcode || ""} zipField="deathZipcode" cityField="deathCity" onChange={onChangeDeathPlaceData} type="death" />
            }
            {(fullForm?.deathplace?.country && fullForm?.deathplace?.country !== "FR") &&
                <>
                    <div className="form-input">
                        <label className="required" htmlFor="deathZipcode">Code postal </label>
                        <input
                            name="deathZipcode"
                            value={fullForm?.deathplace?.zipcode || ""}
                            onChange={onChangeDeathPlaceData}
                            type="text"
                            placeholder="Code postal"
                        />
                    </div>
                    <div className="form-input">
                        <label className="required" htmlFor="deathCity">Ville </label>
                        <input
                            name="deathCity"
                            value={fullForm?.deathplace?.city || ""}
                            onChange={onChangeDeathPlaceData}
                            type="text"
                            placeholder="Ville"
                        />
                    </div>
                </>
            }
            <div className="form-input">
                <label className="required" htmlFor="deathCountry">Pays</label>
                <select
                    required={true}
                    name="deathCountry"
                    value={fullForm?.deathplace?.country || "FR"}
                    onChange={onChangeDeathPlaceData}>
                    {
                        countryList.map((country, index) => (
                            <option key={index} name="country"
                                value={country?.code}>{country?.name}</option>
                        ))
                    }
                </select>
            </div>
        </fieldset>
    );
}